export default ['$timeout', afterNextClickConfiguration]

function afterNextClickConfiguration($timeout) {
  return {
    afterNextClick: (fn) => {
      window.addEventListener(
        'click',
        function _afterNextClick(evt) {
          $timeout(() => fn(evt), 0)
        },
        { once: true, capture: true }
      )
    },
  }
}
